module.exports = __webpack_public_path__ + "static/IcoMoon-Free-5b19fdecc1398211f539eb37dd366511.woff2";